import { jwtDecode } from "jwt-decode";
import { getPlayerServiceClient, LS_TOKEN_KEY } from "@/services/playerService";
import { User } from "@/types";

export const storeAuthToken = (token: string) => {
    const user = parseJWTToken(token);
    if (user) {
        localStorage.setItem(LS_TOKEN_KEY, token);
    } else {
        localStorage.removeItem(LS_TOKEN_KEY);
    }
    return user;
}

export const getStoredAuthToken = () => {
    const token = localStorage.getItem(LS_TOKEN_KEY);
    return {
        token,
        user: token ? parseJWTToken(token) : undefined
    }
}

export const clearAuthToken = () => {
    getPlayerServiceClient().then(client => {
        client.clearLocalStorageAuthData();
    }).finally(() => {
        localStorage.removeItem(LS_TOKEN_KEY);
    });
    //hack to clear all keys that contains `gctAuthToken`
    //as clearLocalStorageAuthData as not working.
    Object.keys(localStorage).map((key => {
        if (key.indexOf('gctAuthToken') >= 0) {
            localStorage.removeItem(key);
        }
    }));
}

export const parseJWTToken = (token: string): User | undefined => {
    try {
        const jwt = jwtDecode(token) as any;
        if (jwt.exp && jwt.exp * 1000 > Date.now()) {
            return {
                appId: jwt.aud as string,
                userId: jwt.gct as string,
                platformPlayerId: jwt.sub,
                provider: jwt.idp === 'guest' ? 'internal' : jwt.idp,
                platform: jwt.iss,
                role: jwt.role || "user"
            };
        }
    } catch (e) {
        console.error("Could not parse JWT token " + token + ", Error: ", e);
    }
}
